import React from 'react'
import PropTypes from 'prop-types'
import ExperienceBadge from './ExperienceBadge'
import { WHERE_LABELS, WHERE_COLOR_VARIANT } from './experienceNavigation'

/**
 * Collapsible Build accordion card (.sec in v7 mock).
 */
const ExperienceAccordionSection = ({
  id,
  title,
  where = [],
  meta,
  expanded,
  onToggle,
  children,
}) => (
  <div
    id={id}
    className={`experience-sec${expanded ? '' : ' collapsed'}`}
    data-build-section={id}>
    <button
      type='button'
      className='experience-sec-head'
      onClick={onToggle}
      aria-expanded={expanded}>
      <h3>{title}</h3>
      {where.map((key) => (
        <ExperienceBadge
          key={key}
          title={WHERE_LABELS[key] || key}
          variant={WHERE_COLOR_VARIANT[key] || 'taupe'}
        />
      ))}
      {meta ? <span className='experience-sec-meta'>{meta}</span> : null}
      <span className='experience-caret' aria-hidden='true'>
        {expanded ? '▴' : '▾'}
      </span>
    </button>
    {expanded ? <div className='experience-sec-body'>{children}</div> : null}
  </div>
)

ExperienceAccordionSection.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  where: PropTypes.arrayOf(PropTypes.string),
  meta: PropTypes.node,
  expanded: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  children: PropTypes.node,
}

export default ExperienceAccordionSection
